"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

/**
 * @function
 *
 * @param {object} props
 * @param {object} [props.boxProps={}]
 * @param {object} [props.circularProps={}]
 * @param {boolean} [props.isLoading=false]
 * @param {React.ReactNode} [props.children=null]
 * @returns {React.ReactElement}
 *
 * @example
 * // TODO: Write example
 */
var AlyceLoading = function AlyceLoading(_ref) {
  var boxProps = _ref.boxProps,
      circularProps = _ref.circularProps,
      isLoading = _ref.isLoading,
      children = _ref.children;
  return isLoading ? /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    width: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: 4,
    mb: 4
  }, boxProps), /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, circularProps)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};

AlyceLoading.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  boxProps: _propTypes["default"].object,
  // eslint-disable-next-line react/forbid-prop-types
  circularProps: _propTypes["default"].object,
  children: _propTypes["default"].node,
  isLoading: _propTypes["default"].bool
};
AlyceLoading.defaultProps = {
  isLoading: false,
  children: null,
  boxProps: {},
  circularProps: {}
};
var _default = AlyceLoading;
exports["default"] = _default;